import { render, staticRenderFns } from "./userInfoWaterMark.vue?vue&type=template&id=5168daeb&"
import script from "./userInfoWaterMark.vue?vue&type=script&lang=js&"
export * from "./userInfoWaterMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "output/userInfoWaterMark.vue"
export default component.exports